/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import LogRocket from 'logrocket';
window.LogRocket = LogRocket;

import Alpine from 'alpinejs'
if (!window.Alpine) {
    window.Alpine = Alpine;
    Alpine.start();
}

//jquery components
require('select2');
require('bootstrap-datepicker');
require('jquery.hotkeys');
//require('dropzone');
const SwalLib = require('sweetalert2/dist/sweetalert2.js');
// Apply dark/light theme based on the app's dark-mode class
const SwalThemed = SwalLib.mixin({
    get theme() {
        return document.documentElement.classList.contains('dark-mode') ? 'dark' : 'light';
    }
});
// Proxy makes Swal() callable (v7 compat) while keeping Swal.fire(), Swal.mixin() etc.
window.Swal = window.swal = new Proxy(SwalThemed.fire.bind(SwalThemed), {
    get(target, prop) {
        if (prop in SwalThemed) {
            const val = SwalThemed[prop];
            return typeof val === 'function' ? val.bind(SwalThemed) : val;
        }
        return target[prop];
    }
});
window.multi = require('multi.js/dist/multi.min.js');
window.daterangepicker = require('daterangepicker');
window.moment = require('moment');
window.toastr = require('toastr');
window.Sticky = require('sticky-js');
window.Compress = require('client-compress');
window.list = require('list.js');
window.Sortable = require('sortablejs').default;
//window.Chart = require('chart.js'); //2.9.4
window.Switchery = require('switchery');
window.html2canvas = require('html2canvas');
//window.matchHeight = require('/resources/plugins/_core/matchHeight/jquery.matchHeight.js');

import Chart from 'chart.js/auto';
window.Chart = Chart;
import { FunnelController, TrapezoidElement } from 'chartjs-chart-funnel';
Chart.register(FunnelController, TrapezoidElement);

import { jsPDF } from "jspdf";
window.jsPDF = jsPDF;

import { MarkerClusterer } from "@googlemaps/markerclusterer";
window.MarkerClusterer = MarkerClusterer;

import { easepick, RangePlugin, AmpPlugin, LockPlugin, PresetPlugin } from '@easepick/bundle';
window.easepick = window.Easepick = easepick;
window.RangePlugin = RangePlugin;
window.AmpPlugin = AmpPlugin;
window.LockPlugin = LockPlugin;
window.PresetPlugin = PresetPlugin;

//editors
import tinymce from 'tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

// Importing plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';

//require('tippy.js');
//require('shepherd.js');
// STFU SHEPHERD
window.Shepherd = window.shepherd = require('shepherd.js/dist/js/shepherd.min.js');

//vanilla js
import LazyLoad from "vanilla-lazyload";
const lazyLoadOptions = {
    threshold: 200,
    elements_selector: ".lazy",
    callback_loaded: function (element) {
        $(element).fadeTo(0, 0).fadeTo(100, 1);
    }
};
var pageLazyLoad = new LazyLoad(lazyLoadOptions);

import hotkeys from 'hotkeys-js';

import emailSpellChecker from '@zootools/email-spell-checker';
window.emailSpellChecker = emailSpellChecker;

import { Calendar } from '@fullcalendar/core';
window.Calendar = Calendar;

import en_gbLocale from '@fullcalendar/core/locales/en-gb';
window.en_gbLocale = en_gbLocale;

import dayGridPlugin from '@fullcalendar/daygrid';
window.dayGridPlugin = dayGridPlugin;

import timeGridPlugin from '@fullcalendar/timegrid';
window.timeGridPlugin = timeGridPlugin;

import listPlugin from '@fullcalendar/list';
window.listPlugin = listPlugin;

import interactionPlugin from '@fullcalendar/interaction';
window.interactionPlugin = interactionPlugin;

//import ImageTools from "./ImageTools.js";  //use in code = const imageTools = new ImageTools();
//window.ImageTools = ImageTools;

import Handlebars from 'handlebars/dist/cjs/handlebars';
window.Handlebars = Handlebars;
//window.Handlebars = require("handlebars");

//import ResizeObserver from 'resize-observer-polyfill';

//import $ from 'jquery';
//import 'select2';
//import 'select2/dist/css/select2.css'; //pulling direct in BS4 SCSS

//import select2 from 'select2';
//Hook up deps to jQuery
//select2($);

/*NOTE - will need to add below to package.json to make work again
"vue": "^2.6.10",
"vue-template-compiler": "^2.6.10",
*/
//window.Vue = require('vue');
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*Vue.component('chat-application', require('./components/ChatApplication.vue'))

const app = new Vue({
    el: '#vue',
    data: {
        userID: null
    },
    mounted() {
        // Assign the ID from meta tag for future use in application
        this.userID = document.head.querySelector('meta[name="user_id"]').content
    }
});*/
